!(function (t) {
  function e(e) {
    for (var r, c, u = e[0], a = e[1], s = e[2], l = 0, d = []; l < u.length; l++)
      (c = u[l]), Object.prototype.hasOwnProperty.call(o, c) && o[c] && d.push(o[c][0]), (o[c] = 0);
    for (r in a) Object.prototype.hasOwnProperty.call(a, r) && (t[r] = a[r]);
    for (p && p(e); d.length; ) d.shift()();
    return i.push.apply(i, s || []), n();
  }
  function n() {
    for (var t, e = 0; e < i.length; e++) {
      for (var n = i[e], r = !0, u = 1; u < n.length; u++) {
        var a = n[u];
        0 !== o[a] && (r = !1);
      }
      r && (i.splice(e--, 1), (t = c((c.s = n[0]))));
    }
    return t;
  }
  var r = {},
    o = { 2: 0 },
    i = [];
  function c(e) {
    if (r[e]) return r[e].exports;
    var n = (r[e] = { i: e, l: !1, exports: {} });
    return t[e].call(n.exports, n, n.exports, c), (n.l = !0), n.exports;
  }
  (c.m = t),
    (c.c = r),
    (c.d = function (t, e, n) {
      c.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
    }),
    (c.r = function (t) {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (c.t = function (t, e) {
      if ((1 & e && (t = c(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (
        (c.r(n),
        Object.defineProperty(n, 'default', { enumerable: !0, value: t }),
        2 & e && 'string' != typeof t)
      )
        for (var r in t)
          c.d(
            n,
            r,
            function (e) {
              return t[e];
            }.bind(null, r)
          );
      return n;
    }),
    (c.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return c.d(e, 'a', e), e;
    }),
    (c.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (c.p = '');
  var u = (window.shopifySlateJsonp = window.shopifySlateJsonp || []),
    a = u.push.bind(u);
  (u.push = e), (u = u.slice());
  for (var s = 0; s < u.length; s++) e(u[s]);
  var p = a;
  i.push([223, 0, 1]), n();
})({
  143: function (t, e, n) {},
  16: function (t, e) {
    var n;
    n = (function () {
      return this;
    })();
    try {
      n = n || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (n = window);
    }
    t.exports = n;
  },
  223: function (t, e, n) {
    'use strict';
    n.r(e), n(143);
    var r = n(1),
      o = n(0);
    const i = '.special-instructions',
      c = '.os-header__heading',
      u = 'data-checkout-discount-amount-target',
      a = '[data-checkout-total-shipping-target]';
    n(8), n(6), n(22), n(3);
    function s() {
      (() => {
        const t = {
          attribute: document.querySelector(i),
          container: document.querySelector(c),
          discountAmount: document.querySelector('['.concat(u, ']')),
          shippingTotal: document.querySelector(a),
          radioInputs: document.querySelectorAll('input[type=radio]'),
          radioRow: document.querySelectorAll('.content-box__row'),
        };
        return Object.freeze({
          init: function () {
            Shopify.Checkout.isOrderStatusPage &&
              t.attribute &&
              (t.container.appendChild(t.attribute), t.attribute.classList.remove(r.a.hidden)),
              t.discountAmount &&
                (t.discountAmount.getAttribute(u) > 0 || (t.discountAmount.style.display = 'none')),
              t.radioInputs &&
                t.radioInputs.forEach(e => {
                  Object(o.h)('click', e, e =>
                    (function (e) {
                      const n = e.target.closest('.content-box__row');
                      t.radioRow.forEach(t => {
                        t.classList.remove(r.a.active);
                      }),
                        n.classList.add(r.a.active);
                    })(e)
                  );
                }),
              window.setTimeout(() => {
                'Free' === t.shippingTotal.innerText && (t.shippingTotal.style.fontWeight = '600');
              }, 250);
          },
        });
      })().init(),
        (() => {
          let properties = [...document.querySelectorAll('.order-summary__small-text')];

          // Define the sort order
          let sortOrder = ['To', 'From', 'Message'];

          // Sort the properties based on the sortOrder
          properties.sort((a, b) => {
            let aIndex = sortOrder.findIndex(item => a.innerHTML.includes(item));
            let bIndex = sortOrder.findIndex(item => b.innerHTML.includes(item));
            return aIndex - bIndex;
          });

          // Reinsert the sorted properties back into the DOM
          properties.forEach(property => {
            property.parentNode.appendChild(property);
          });

          // Now assign sorted properties to t.properties
          const t = {
            products: [...document.querySelectorAll('.product')],
            properties: properties,
          };

          return Object.freeze({
            init: function () {
              t.products.map(t => {
                'Gift Wrap' === t.getAttribute('data-product-type') && (t.style.display = 'none');
              });

              t.properties.map(t => {
                const e = t.innerHTML;
                (e.includes('Fabric:') ||
                  e.includes('Cushion Fill:') ||
                  e.includes('Gift Wrap: No')) &&
                  (t.style.display = 'none');

                if (t.innerHTML.includes('Gift Message')) {
                  const e = t.innerHTML.replace(/Gift Message /g, '');
                  t.innerHTML = e;
                  t.classList.add('gift-message');
                }

                if (t.innerHTML.includes('Gift Wrap:')) {
                  const e = t.innerHTML.split('+')[1],
                    n = t.innerHTML.replace('Gift Wrap: ', '').split('+')[0];
                  t.innerHTML = ''.concat(n, ' <span>+').concat(e, '</span>');
                  t.classList.add('gift-wrap');
                  t.parentNode.parentNode.classList.add('gift-wrap');
                }
              });

              // Move gift-wrap and gift-message
              document.querySelectorAll('tr.product').forEach(t => {
                const input = document.createElement('span');
                input.innerHTML =
                  "<a href='/cart' style='font-size: 12.64198px; line-height: 1.25; color: #717171; text-decoration: underline;'>edit in cart</a>";

                let e = t.querySelector('.product__description__property.gift-message');
                let n = t.querySelector('.product__description__property.gift-wrap');

                if (e) {
                  const beforeElements = t.querySelectorAll(
                    '.product__description__property.gift-message'
                  );

                  if (beforeElements.length > 0) {
                    beforeElements[beforeElements.length - 1].after(input);
                  } else {
                    e.before(n);
                    e.after(input);
                  }
                } else {
                  e = t.querySelector('.product__description__property.gift-wrap');
                  if (e) {
                    e.after(input);
                  }
                }
              });
            },
          });
        })().init();
    }
    document.addEventListener('page:load', s),
      document.addEventListener('page:change', s),
      document.addEventListener('page:update', s);
  },
});
